export const getRamadanDates = (hijriAdjustment: number = 0): { start: Date; end: Date } => {
  const today = new Date();
  const adjustedToday = new Date(today);
  adjustedToday.setDate(adjustedToday.getDate() + hijriAdjustment);
  
  const hijriFormatter = new Intl.DateTimeFormat('en-u-ca-islamic', {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric'
  });
  
  const parts = hijriFormatter.formatToParts(adjustedToday);
  const currentYear = parseInt(parts.find(p => p.type === 'year')?.value || '1446');
  
  let searchDate = new Date(today);
  searchDate.setMonth(0, 1);
  
  let ramadanStart: Date | null = null;
  let ramadanEnd: Date | null = null;
  
  for (let i = 0; i < 400; i++) {
    const testDate = new Date(searchDate);
    testDate.setDate(testDate.getDate() + i);
    const adjustedTest = new Date(testDate);
    adjustedTest.setDate(adjustedTest.getDate() + hijriAdjustment);
    
    const testParts = hijriFormatter.formatToParts(adjustedTest);
    const year = parseInt(testParts.find(p => p.type === 'year')?.value || '0');
    const month = parseInt(testParts.find(p => p.type === 'month')?.value || '0');
    const day = parseInt(testParts.find(p => p.type === 'day')?.value || '0');
    
    if (year === currentYear && month === 9 && day === 1) {
      ramadanStart = testDate;
      break;
    }
  }
  
  if (ramadanStart) {
    for (let i = 28; i < 32; i++) {
      const testDate = new Date(ramadanStart);
      testDate.setDate(testDate.getDate() + i);
      const adjustedTest = new Date(testDate);
      adjustedTest.setDate(adjustedTest.getDate() + hijriAdjustment);
      
      const testParts = hijriFormatter.formatToParts(adjustedTest);
      const month = parseInt(testParts.find(p => p.type === 'month')?.value || '0');
      const day = parseInt(testParts.find(p => p.type === 'day')?.value || '0');
      
      if (month === 10 && day === 1) {
        ramadanEnd = new Date(testDate);
        ramadanEnd.setDate(ramadanEnd.getDate() - 1);
        break;
      }
    }
  }
  
  if (!ramadanStart || !ramadanEnd) {
    return {
      start: new Date('2026-02-18'),
      end: new Date('2026-03-19')
    };
  }
  
  return { start: ramadanStart, end: ramadanEnd };
};
